import {useCallback, useState} from 'react';

import {asyncResult} from 'utils/async_result';

const canUsePermission = 'Notification' in window;

export function useNotificationPermission() {
    const [granted, setGranted] = useState(canUsePermission && Notification.permission === 'granted');

    const requestPermission = useCallback(() => asyncResult<NotificationPermission>(async () => {
        if (!canUsePermission) {
            throw Error('Notifications API is not available');
        }

        if (Notification.permission === 'granted') {
            return 'granted';
        }

        const permission = await Notification.requestPermission();

        setGranted(permission === 'granted');

        return permission;
    }), []);

    return {
        granted,
        canUsePermission,
        requestPermission,
    };
}
